module.exports = __webpack_public_path__ + "static/media/App.51447390.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/App.scss
// module id = 2832
// module chunks = 0